import assign from 'object-assign';
import InitialState from '../InitialState';
import * as OrderActionTypes from '../ActionTypes';
import * as ActionTypes from './ActionTypes';

export default function orderTextReducer(
    state: any = InitialState.viewOrder.text,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.GET_TEXT_INFO_SUCCESS:
        case ActionTypes.SET_TEXT_AS_NOT_DELIVERED_SUCCESS:
        case ActionTypes.SET_TEXT_DELIVERED_SUCCESS: {
            return {
                ...state,
                text: action.result
            }
        }

        case OrderActionTypes.RESET_ORDER_STATES:
            return InitialState.viewOrder.text;
        
        case ActionTypes.GET_AVAILABLE_COPYWRITERS_SUCCESS: {
            return {
                ...state,
                availableCopywriters: action.result
            }
        }

        case ActionTypes.SET_COPYWRITER_ON_ORDER_SUCCESS: {
            return {
                ...state,
                text: {
                    ...state.text,
                    selectedCopywriterId: action.result
                }
            }
        }

        default:
            return state;
    }
}
